// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1cn0i","tab":"ProcedureTabs_tab__2XZDx"};